import React from 'react';
import useStyle from './signInContent.style';
import { FormLogin } from 'components/molecules/Forms/FormLogin';

export interface SignInContentProps {
  mailValue: string;
  onChangeMailValue: (event: any) => void;
  mailError?: any;
  passwordValue: string;
  onChangePasswordValue: (event: any) => void;
  passwordError?: any;
  onClickConnect: () => Promise<void>;
  createAccountLink?: string;
  passwordLostLink?: string;
  isValid?: boolean;
  loading: boolean;
}

export const SignInContent = ({
  mailValue,
  onChangeMailValue,
  mailError,
  passwordValue,
  onChangePasswordValue,
  passwordError,
  onClickConnect,
  // createAccountLink,
  passwordLostLink,
  isValid = true,
  loading
}: SignInContentProps) => {
  const classes = useStyle();

  return (
    <div className={classes.root}>
      <h1 className={classes.title}>Bienvenue sur France Challenges</h1>
      <div className={classes.content}>
        <FormLogin
          mailValue={mailValue}
          onChangeMailValue={onChangeMailValue}
          passwordValue={passwordValue}
          onChangePasswordValue={onChangePasswordValue}
          onClickConnect={onClickConnect}
          helperTextMail={mailError}
          helperTextPassword={passwordError}
          passwordLostLink={passwordLostLink}
          isValid={isValid}
          loading={loading}
        />
        <div className={classes.help}>
          <div>
            <p className={classes.space}>Professeur sans compte ?</p>
            <span className={classes.littleText}>
              Veuillez contacter France Challenges.
            </span>
          </div>
          <div>
            <p>Élève ?</p>
            <span className={classes.littleText}>
              Veuillez demander un accès à votre professeur.
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};
